import styled from "styled-components";
import { GrayUserIcon, LockIcon } from "../assets/icons/icons";
import userStorage from "../utils/userStorage";
import { textSubstring } from "../utils/util";
import { CustomTooltip } from "./common/CustomTooltip";
import AlertModal from "./alertModal";
import theme from "../theme";
import { useState } from "react";
import { useI18n } from "../locales";
import { postPwCheck } from "../api/admin";
import { useSnackbar } from "notistack";
import { useMutation } from "@tanstack/react-query";
import { useWindowSize } from "@reactuses/core";
import { AlertModalInput } from "./alertModalInput";
import { SystemSetting } from "../types/types";

type Prop = {
  onNext: () => void;
  isControlPage?: boolean; // 관제 페이지
  systemSetting: SystemSetting | null;
};

const { md } = theme.screen;

export const HeaderUser = ({ onNext, isControlPage }: Prop) => {
  const { t } = useI18n();
  const user = userStorage.get();
  const { enqueueSnackbar } = useSnackbar();
  const { width } = useWindowSize();
  const [openMyPage, setOpenMyPage] = useState(false);
  const [pw, setPw] = useState("");

  const mutation = useMutation({
    mutationFn: postPwCheck,
    onSuccess: () => {
      setOpenMyPage(false);
      onNext();
      setPw("");
      enqueueSnackbar(`비밀번호가 확인되었습니다.`, {
        variant: "success",
      });
    },
    onError: () => {
      enqueueSnackbar(`비밀번호가 일치하지 않습니다.`, {
        variant: "error",
      });
    },
  });

  const handleClickYesPw = () => {
    mutation.mutate({ pw /*: SHA256(pw).toString()*/ });
  };

  const handleClickNoPw = () => {
    setOpenMyPage(false);
    setPw("");
  };

  return (
    <>
      {!isControlPage && (
        <CustomTooltip
          title={user?.name}
          active={user && user.name?.length > 7}
        >
          <Wrapper>
            <GrayUserIcon />
            <HeaderFont onClick={() => setOpenMyPage(true)}>
              {`${textSubstring(user?.name, 0, 7)}${t.navigation.honorific}`}
            </HeaderFont>
          </Wrapper>
        </CustomTooltip>
      )}

      {/* 안전관제 페이지 헤더 */}
      {isControlPage &&
        (width > md ? (
          <CustomTooltip
            title={user?.name}
            active={user && user.name.length > 3}
          >
            <ControlWrapper>
              <GrayUserIcon />
              <HeaderFont
                onClick={() => setOpenMyPage(true)}
                fontSize="12px"
              >
                {`${textSubstring(user?.name, 0, 3)}${t.navigation.honorific}`}
              </HeaderFont>
            </ControlWrapper>
          </CustomTooltip>
        ) : (
          <ControlWrapper onClick={() => setOpenMyPage(true)}>
            <GrayUserIcon width={20} height={20} />
          </ControlWrapper>
        ))}

      <AlertModal
        open={openMyPage}
        onPressNo={handleClickNoPw}
        title={t.manageUser.viewAccountInfo}
        content={t.manageUser.enterPasswordForPrivacy}
        confirmText={mutation.isPending ? t.manageUser.confirming : t.common.confirm}
        other={
          <AlertModalInput
            onChange={(e) => setPw(e.target.value)}
            placeholder={t.manageUser.enterPasswordPlaceholder}
            value={pw}
            type="password"
          />
        }
        onPressYes={handleClickYesPw}
        icon={<LockIcon />}
        otherFilled={Boolean(pw.length)}
      />
    </>
  );
};

const Wrapper = styled.button`
  display: flex;
  align-items: center;
  gap: 7px;
  &:hover div {
    color: ${theme.statusColor.MAIN};
  }
  &:hover svg path {
    fill: ${theme.statusColor.MAIN};
  }
`;

const ControlWrapper = styled.button`
  display: flex;
  gap: 7px;

  &:hover div {
    color: ${theme.statusColor.MAIN};
  }
  &:hover svg path {
    fill: ${theme.statusColor.MAIN};
  }
  @media (min-width: ${md + 1}px) {
    padding-top: 20px;
    padding-bottom: 10px;
  }
`;

const HeaderFont = styled.div<{ fontSize?: string }>`
  font-weight: 400;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : "13px")};
  line-height: 15px;
  color: ${theme.color.neutral_400};
  cursor: pointer;
`;
